import { motion } from 'framer-motion';

const Partnerships = () => {
  const partners = [
    { name: 'Global Institute of Problem Studies', type: 'Research Partner', icon: 'ri-flask-line' },
    { name: 'International Crisis Recognition Board', type: 'Certification Body', icon: 'ri-award-line' },
    { name: 'Society for Complicated Matters', type: 'Professional Association', icon: 'ri-team-line' },
    { name: 'Academy of Unresolved Issues', type: 'Academic Affiliate', icon: 'ri-graduation-cap-line' },
    { name: 'World Problem Conservation Foundation', type: 'Strategic Partner', icon: 'ri-earth-line' },
    { name: 'Federation of Escalation Professionals', type: 'Industry Alliance', icon: 'ri-shield-check-line' },
  ];

  return (
    <section className="relative py-36 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3f96800585ad260dfb3d59eafc2317bf.jpg"
          alt="Mountain peaks at sunset"
          width={1920}
          height={1080}
          loading="lazy"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/85 to-black/90"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-charcoal/80 backdrop-blur-sm border-l-8 border-gold p-12 lg:p-16 rounded-lg"
        >
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">
              Prestigious Partnerships & Affiliations
            </h2>
            <p className="text-xl text-light-gray leading-relaxed max-w-3xl">
              The Real Problem Company maintains strategic relationships with the world's leading problem identification organizations, ensuring our methodologies remain at the forefront of issue recognition and escalation.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {partners.map((partner, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group"
              >
                <div className="bg-black/50 backdrop-blur-sm border border-gold/20 rounded-lg p-6 h-full transition-all duration-300 hover:border-gold/60 hover:bg-black/70">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full border-2 border-gold flex items-center justify-center flex-shrink-0 group-hover:bg-gold/10 transition-colors duration-300">
                      <i className={`${partner.icon} text-gold text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white mb-1 group-hover:text-gold transition-colors duration-300">
                        {partner.name}
                      </h3>
                      <p className="text-sm text-light-gray">{partner.type}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 pt-8 border-t border-gold/30"
          >
            <p className="text-light-gray text-center italic">
              "These partnerships enable us to deliver world-class problem identification services while maintaining our unwavering commitment to never actually solving anything."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Partnerships;